module.exports = function (a) {
    let author = $(this).data('author');
    let composer = $(this).data('composer');
    let isrc = $(this).data('isrc');

    let html = '';
    if(composer != '' && composer == author){
        html = html+'<p>' + Lang.get('authorisations.info_dialog.author_and_composer') + ': <br><span class="label label-inverse">'+composer+'</span></p>';
    }else{
        if(composer != ''){
            html = html+'<p>' + Lang.get('authorisations.info_dialog.composer') + ': <br><span class="label label-inverse">'+composer+'</span></p>';
        }
        if(author != ''){
            html = html+'<p>' + Lang.get('authorisations.info_dialog.author') + ': <br><span class="label label-inverse">'+author+'</span></p>';
        }
    }

    if(isrc != ''){
        html = html+'<p>' + Lang.get('authorisations.info_dialog.isrc_code') + ': <br><span class="label label-inverse">'+isrc+'</span></p>';
    }

    bootbox.alert(html, function() {
        //console.log("Alert Callback");
    });
};
